exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PatientConsentForMedicalRecordsExchange--kENcr3ZeTM1ENntdxkZDa {\n  padding-bottom: 30px;\n}\n", ""]);

// exports
exports.locals = {
	"mainContent": "PatientConsentForMedicalRecordsExchange--kENcr3ZeTM1ENntdxkZDa",
	"mainContent": "PatientConsentForMedicalRecordsExchange--kENcr3ZeTM1ENntdxkZDa"
};